import { Assessment } from '@/models/Assessment';

export const findCloneByOrder = (assessments: Assessment[], order: number) =>
  assessments?.find(a => a.order === order);
